var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.getFichaById(_vm.id).section.right && !_vm.getFichaById(_vm.id).section.right.static)?_c('el-button',{attrs:{"size":"small","icon":_vm.getFichaById(_vm.id).section.right.open ? 'el-icon-s-unfold' : 'el-icon-s-fold'},on:{"click":function($event){return _vm.setFichaVisibleSection({id: _vm.id, section: 'right'})}}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }